import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
} from "components/ui/dialog";
import { Button } from "components/ui/button";
import { Formik } from "formik";
import Text from "components/Text";
import { fontSizes } from "appconstants";
import InputField from "components/InputField";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import ErrorText from "components/ErrorText";
import { add_room_store_validation_schema } from "validation_schema/add_room_store_validation_schema";

interface Props {
    open: boolean;
    onClose: () => void;
    isStore?: boolean
    onAdd: Function
}

const CustomModal = ({ open, onClose, isStore, onAdd }: Props) => {
    const { user_loading } = useSelector((state: RootState) => state.user);

    return (
        <Dialog open={open} onOpenChange={user_loading ? null : onClose}>
            <DialogContent className="max-w-[720px] rounded-xl">
                <DialogTitle className="hidden"></DialogTitle>
                <DialogDescription className="hidden"></DialogDescription>

                <Text text={`Add ${isStore ? 'Store' : 'Room'}`} className="font-bold" size={fontSizes.h20} />
                <Text text={`Fill in the details to add a new ${isStore ? 'store' : 'room'}.`} className='text-muted-foreground mt-0' />

                <Formik
                    initialValues={{ name: "" }}
                    validationSchema={add_room_store_validation_schema}
                    onSubmit={(values, functions) => onAdd(values, functions)}
                >
                    {({
                        values,
                        errors,
                        handleSubmit,
                        resetForm,
                        handleChange
                    }) => (
                        <>
                            <div className="grid grid-cols-1 gap-4 mt-5">
                                <div>
                                    <InputField
                                        label={`${isStore ? 'Store' : 'Room'} Name`}
                                        placeholder={`Enter ${isStore ? 'Store' : 'Room'} Name`}
                                        value={values?.name}
                                        onChange={handleChange("name")}
                                    />
                                    <ErrorText text={errors?.name} />
                                </div>
                            </div>

                            <div className="mt-5 flex justify-between gap-4">
                                <Button
                                    variant="outline"
                                    className="h-12 w-full rounded-xl border-primary text-primary"
                                    onClick={() => {
                                        resetForm();
                                        onClose();
                                    }}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    className="h-12 w-full rounded-xl"
                                    onClick={() => handleSubmit()}
                                    loading={user_loading}
                                >
                                    {"Add"}
                                </Button>
                            </div>
                        </>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default CustomModal;
